import React from 'react';

import {BulkAssemblyMethod, FragmentProductionMethod} from 'molbio/bulk-assembly/BulkAssemblyConstants';
import {FragmentProductionMethodDropdown} from 'molbio/bulk-assembly/setup-modal/controls/FragmentProductionMethodDropdown';

interface GoldenGateBinControlsProps {
  fragmentProductionMethod: FragmentProductionMethod;
  onChangeFragmentProductionMethod: (newFragmentProductionMethod: FragmentProductionMethod) => void;
  isReadOnly: boolean;
}

export function GoldenGateBinControls(props: GoldenGateBinControlsProps): JSX.Element {
  return (
    <FragmentProductionMethodDropdown
      fragmentProductionMethod={props.fragmentProductionMethod}
      updateFragmentProductionMethod={props.onChangeFragmentProductionMethod}
      dropdownMethods={[FragmentProductionMethod.EXISTING_CUT_SITES, FragmentProductionMethod.PRIMER_PAIR]}
      bulkAssemblyMethod={BulkAssemblyMethod.GOLDEN_GATE}
      hideLabels={true}
      disabled={props.isReadOnly}
    />
  );
}
